import React from 'react';
import styles from './Pricing.module.css';
import useScrollReveal from './hooks/useScrollReveal';
import Header from './Section/Header';
import Fees from './Section/Fees';
import Plans from './Section/Plans';
import Faq from './Section/Faq';
import CallToAction from './Section/CallToAction';

const Pricing = () => {
  useScrollReveal('[data-sr]');

  return (
    <div className={styles.page}>
      <Header />
      <Fees />
      <Plans />
      <Faq />
      <CallToAction />
    </div>
  );
};

export default Pricing;
